import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

import { FeaturesView } from './service-providers-features.view';

export const Features = (props) => {
  const {
    illustrationFeatures: {
      childImageSharp: { fixed: illustrationFeaturesFixed },
    },
  } = useStaticQuery(graphql`
    query {
      illustrationFeatures: file(
        relativePath: { eq: "pages/service-providers/features/map@2x.png" }
      ) {
        childImageSharp {
          fixed(height: 743) {
            ...GatsbyImageSharpFixed_withWebp_noBase64
          }
        }
      }
    }
  `);
  return <FeaturesView {...props} illustration={illustrationFeaturesFixed} />;
};
